import debug from 'debug';

debug.log = console.log.bind(console);

export default debug;
